module.exports = __webpack_public_path__ + "static/media/Artboard7.749ab8da.png";